<template>
  <b-form-checkbox v-model="checked" @change="$emit('change', $event)" :disabled="disabled" class="price-range">
    Usar faixa de preço
  </b-form-checkbox>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'PriceRangeCheckbox',
  components: {
    BFormCheckbox
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checked: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style scoped>
.price-range .custom-control-label {
  background-color: red;
}
</style>